import React, { useContext, useEffect } from 'react'
import Sidebar from '../Components/Sidebar';
import { Typography } from '@mui/material';
import { getCookie, parseJwt, getAccessToken, setCookie,getAuthPassAccessToken } from '../common';
import { useNavigate } from 'react-router-dom';
import { UserContext} from '../Hook/UserContext';
import AppInsight from "../AppInsight";


const Login = () => {
  const navigate = useNavigate();
  const {userRole,code1,setCode} = useContext(UserContext);
  let params = (new URL(document.location.href)).searchParams;
  const code = params.get("code");
  // const CODE_CHALLENGE = crypto
  // .createHash('sha256')
  // .update(process.env.REACT_APP_PING_CODE_VERIFIER)
  // .digest('base64')
  // .replace(/=/g, '')
  // .replace(/\+/g, '-')

  // .replace(/\//g, '_');

  const getSHA256Hash = async (input) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  const hashBuffer = await window.crypto.subtle.digest('SHA-256',data);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const base64Hash= btoa(String.fromCharCode(...hashArray));

  return base64Hash.replace(/=/g, '')
  .replace(/\+/g, '-')
  .replace(/\//g, '_');


  }


  // const getSHA256Hash = async (input) => {
  //   const textAsBuffer = new TextEncoder().encode(input);
  //   const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
  //   const hashArray = Array.from(new Uint8Array(hashBuffer));
  //   const hash = hashArray
  //     .map((item) => item.toString(16).padStart(2, "0"))
  //     .join("");
  //   return hash;
  // };

 

  useEffect(() => {

    const codeChallengeVar="";
    getSHA256Hash(process.env.REACT_APP_PING_CODE_VERIFIER).then(
      (codeChallengeVar)=>{
        if (!code && (getCookie('authAccessTokenInfo') == '' || getCookie('authAccessTokenInfo') == null)) {
          const url = `${process.env.REACT_APP_PING_AUTH_URI}?response_type=${process.env.REACT_APP_PING_RESPONSE_TYPE}&client_id=${process.env.REACT_APP_PING_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_PING_REDIRECT_URI}&acr_values=${process.env.REACT_APP_PING_ACR_VALUES}&scope=${process.env.REACT_APP_PING_SCOPE}&code_challenge=${codeChallengeVar}&code_challenge_method=${process.env.REACT_APP_PING_CODE_CHALLENGE_METHOD}`;
          window.location = url;
        } else {
          if (getCookie('authPassAcessTokenInfo')==''||getCookie('authPassAcessTokenInfo')==null) {
            getAccessToken(code).then(response => {
              if (response?.data?.access_token !== undefined) {
                const userData = parseJwt(response?.data?.id_token);
                var minutesDiff = (userData.exp - userData.iat) / 60;
                setCookie('refreshToken', response?.data?.refresh_token); //setting cookie
                setCookie('authAccessTokenInfo', response?.data?.access_token, minutesDiff); //setting cookie
                getAuthPassAccessToken(response?.data?.access_token)
                  .then(res => {
                    // console.log("Auth pass token success:", res.data);
                    if(res?.data?.access_token!==undefined){
                      const authPassAccessTokenDecode=parseJwt(res?.data?.access_token);
                      const roleName=authPassAccessTokenDecode["func-roles"].map(item=>item.roleName);
                      // console.log("roleName",roleName);
                      setCookie('authPassAccessToken',res?.data?.access_token,minutesDiff);
                      setCookie("authPassAcessTokenInfo",JSON.stringify(authPassAccessTokenDecode), minutesDiff);
                      setCookie("roleName",roleName);
                      setCookie('userInfo', JSON.stringify(userData), minutesDiff); //setting cookie
                      setCode(code);
                    }
                  })
                  .catch(err => {
                    AppInsight.trackEvent({ name: `PNA Frontend =>getAuthPassAccessToken => Login=>`, properties: { errorMessage: err.message } });
                  });
              }
            }).catch(err => {
            });
          }
        }

      }
    );

    
   
  }, [])
  return (
    <div className="container " style={{ margin: '0px', padding: '0px' }}>
      <div class="left-panel">
        <Sidebar defaultValue="Home" />
      </div>
      <div className="right-panel">

        <div style={{ paddingTop: '15%' }}>
          <Typography variant="h6" gutterBottom>
            Please wait while we are logging you in...
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default Login